import * as React from "react";
const SvgDivide = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 11h14v2H5zm7.002-7a2 2 0 1 0-.004 4 2 2 0 0 0 .004-4zm0 12a2 2 0 1 0-.004 4 2 2 0 0 0 .004-4z",
  fill: "currentColor"
}));
export default SvgDivide;